/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.donation;

export const getButton = createSelector(self, (state) => state.button);
export const getButtonData = createSelector(getButton, (state) => state.data);
export const getCurrencies = createSelector(self, (state) => state.currencies);
export const getCurrenciesData = createSelector(getCurrencies, (state) => state.data);
